import { render } from "./ServersBlock.vue?vue&type=template&id=6eb0f124"
import script from "./ServersBlock.vue?vue&type=script&lang=js"
export * from "./ServersBlock.vue?vue&type=script&lang=js"

import exportComponent from "/home/xpixel/htdocs/xpixel.ru/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__